import { render, staticRenderFns } from "./GroupCollectionFiltersNew.vue?vue&type=template&id=9ecd572e"
import script from "./GroupCollectionFiltersNew.vue?vue&type=script&lang=ts"
export * from "./GroupCollectionFiltersNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ecd572e')) {
      api.createRecord('9ecd572e', component.options)
    } else {
      api.reload('9ecd572e', component.options)
    }
    module.hot.accept("./GroupCollectionFiltersNew.vue?vue&type=template&id=9ecd572e", function () {
      api.rerender('9ecd572e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/teams/GroupCollectionFiltersNew.vue"
export default component.exports